module.exports = __webpack_public_path__ + "img/solution-finance-advantage3.7b0b57b0.svg";